var render = function render(){var _vm=this,_c=_vm._self._c;return _c('td',{staticClass:"border-t"},[(_vm.href)?_c('inertia-link',{staticClass:"px-6 py-4 flex items-center",attrs:{"href":_vm.href,"tabindex":"-1"}},[_vm._t("default")],2):_c('div',{staticClass:"px-6 py-4 flex items-center"},[_vm._t("default")],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }